/**
 * Gets formatted locale.
 * @example
 * // returns "en_gb"
 * getFormattedLocale()
 * getFormattedLocale('lowerCase')
 * @example
 * // returns "en_GB"
 * getFormattedLocale('mixed')
 * @example
 * // returns "EN_GB"
 * getFormattedLocale('upperCase')
 * @param {object} localeInfo - Object containing locale info.
 * @param {string|null} format - Type of formatting.
 * @param {string} [separator] - Separator to be used.
 * @returns {string} - Formatted locale if the format is specified.
 */
const getFormattedLocale = (localeInfo, format = 'lowerCase', separator) => {
    const { lang, country, separator: originSeparator } = localeInfo;
    const separatorToUse = separator || originSeparator;
    const localeToUse = originSeparator ? `${lang}${separatorToUse}${country}` : lang;
    switch (format) {
        case 'lowerCase':
            return localeToUse.toLowerCase();
        case 'upperCase':
            return localeToUse.toUpperCase();
        case 'mixed':
            return originSeparator
                ? `${lang.toLowerCase()}${separatorToUse}${country.toUpperCase()}`
                : lang.toLowerCase();
        default:
            return localeToUse;
    }
};
export default getFormattedLocale;
//# sourceMappingURL=getFormattedLocale.js.map